import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--right",
  "use": "icon-arrow--right-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 12\" id=\"icon-arrow--right\"><path d=\"M5.341 5.816a.988.988 0 0 1 1.323 0c.182.17.274.392.274.614a.834.834 0 0 1-.274.613l-4.988 4.625c-.882.818-2.204-.409-1.323-1.226l4.988-4.626v1.227L.353 2.418a.823.823 0 0 1 0-1.227.988.988 0 0 1 1.323 0l4.988 4.625c.182.17.274.392.274.614a.834.834 0 0 1-.274.613l-4.988 4.625-1.323-1.226 4.988-4.626Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol